import { Base64 } from "js-base64"

export enum MLSortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum FileType {
  images = 'images',
  videos = 'videos',
  cssJs = 'cssJs',
  others = 'others',
}

export enum MLSortParams {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  NAME = 'NAME',
  HEIGHT = 'HEIGHT',
  WIDTH = 'WIDTH',
  SIZE = 'SIZE',
  RELEVANCE = 'RELEVANCE',
}

export enum MLViewType {
  LIST = 'LIST',
  GRID = 'GRID',
}

export enum ACLEntityTypeEnum {
  USER = 'USER',
  USER_GROUP = 'USER_GROUP',
  MEDIA_COLLECTION = 'MEDIA_COLLECTION',
}

export enum ACLPermissionEnum {
  READ = 'READ',
  CONTRIBUTE = 'CONTRIBUTE',
  MANAGE = 'MANAGE',
}

export const DEFAULT_SEARCH_NAME_AUTOCOMPLETE_SKIP = 0

export const DEFAULT_SEARCH_NAME_AUTOCOMPLETE_LIMIT = 15

export enum UrlRewriterEum {
  CLOUDINARY = 'CLOUDINARY',
  IMGIX = 'IMGIX',
  AKAMAI = 'AKAMAI',
}

export enum PostTransformationTypes {
  Transformation = 'transformation',
  GifToVideo = 'gif-to-video',
  Thumbnail = 'thumbnail',
  ABS = 'abs',
}

export enum PostTransformationLabels {
  Transformation = 'Transformation',
  GifToVideo = 'Gif to video',
  Thumbnail = 'Thumbnail',
  ABS = 'ABS',
}

export enum Protocol {
  HLS = 'HLS',
  DASH = 'DASH',
}

export enum ProtocolValue {
  HLS = 'hls',
  DASH = 'dash',
}

export enum ThreadSort {
  DESC_CREATED = 'DESC_CREATED',
  DESC_UPDATED = 'DESC_UPDATED',
}

export enum ThreadFilter {
  UNRESOLVED = 'UNRESOLVED',
  ALL = 'ALL',
}

export enum ThreadAction {
  ADD = 'add',
  REMOVE = 'remove',
}

export const MaxPostTransformation = 5

export const BLANK_SEARCH_QUERY_PARAMS: {
  fileType: FileType | ""
  sort: string
  view: MLViewType
  searchQuery: string
  q: string
  semantic: string
  semanticUrl: string
  type: string
  isFolderRestrictedSearch: string
  searchMode: string
  searchInputMode: string
  searchByTags: string
  isVersionIncludedInSearch: string
} = {
  sort: 'DESC_CREATED',
  view: MLViewType.GRID,
  searchQuery: '',
  q: '',
  fileType: "",
  searchMode: 'keyword',
  searchInputMode: 'builder',
  searchByTags: 'true',
  isVersionIncludedInSearch: 'false',

  // legacy
  isFolderRestrictedSearch: 'false',
  type: Base64.encode('type="file"', true),
  semantic: '',
  semanticUrl: '',
}

// Pagination constants
export const foldersPerPage = 1000
export const secondaryFoldersPerPage = 100
export const filesPerPage = 1000
export const mediaCollectionsPerPage = 1000

/**
 * Shared threshold for the custom metadata field forms: past this many fields a
 * form windows its field list and shows a search box. Kept in one place so the
 * preview form, the upload form, and the create/edit upload form all agree on
 * when the list becomes searchable.
 */
export const CMF_VIRTUALIZE_THRESHOLD = 30

// File type mapping
export const fileTypeMapping = {
  images: ['jpg', 'webp', 'png', 'gif', 'svg', 'avif', 'ico', 'heic', 'heif'],
  videos: ['mp4', 'm4v', 'webm', 'mov'],
  cssJs: ['js', 'css', 'ts'],
  others: [
    'jpg',
    'webp',
    'png',
    'gif',
    'svg',
    'avif',
    'ico',
    'mp4',
    'm4v',
    'webm',
    'mov',
    'js',
    'css',
    'ts',
  ],
  font: ["ttf", "otf", "woff", "woff2", "eot"],
}

export const dimensionOptions: {
  [presetDimension: string]: {
    unit: string
    height: {
      min?: number
      max?: number
    }
    width: {
      min?: number
      max?: number
    }
    text: string
  }
} = {
  Icons: {
    unit: 'px',
    height: {
      max: 256,
    },
    width: {
      max: 256,
    },
    text: 'Icons',
  },
  Small: {
    unit: 'px',
    height: {
      min: 256,
      max: 480,
    },
    width: {
      min: 256,
      max: 640,
    },
    text: 'Small',
  },
  Medium: {
    unit: 'px',
    height: {
      min: 480,
      max: 768,
    },
    width: {
      min: 640,
      max: 1024,
    },
    text: 'Medium',
  },
  Large: {
    unit: 'px',
    height: {
      min: 768,
      max: 1080,
    },
    width: {
      min: 1024,
      max: 1920,
    },
    text: 'Large',
  },
  'Larger than 400×300': {
    unit: 'px',
    height: {
      min: 300,
    },
    width: {
      min: 400,
    },
    text: 'Larger than 400×300',
  },
  'Larger than 640×480': {
    unit: 'px',
    height: {
      min: 480,
    },
    width: {
      min: 640,
    },
    text: 'Larger than 640×480',
  },
  'Larger than 800×600': {
    unit: 'px',
    height: {
      min: 600,
    },
    width: {
      min: 800,
    },
    text: 'Larger than 800×600',
  },
  'Larger than 1024×768': {
    unit: 'px',
    height: {
      min: 768,
    },
    width: {
      min: 1024,
    },
    text: 'Larger than 1024×768',
  },
  'Larger than 1600×1200': {
    unit: 'px',
    height: {
      min: 1200,
    },
    width: {
      min: 1600,
    },
    text: 'Larger than 1600×1200',
  },
  'Larger than 1920×1200': {
    unit: 'px',
    height: {
      min: 1200,
    },
    width: {
      min: 1920,
    },
    text: 'Larger than 1920×1200',
  },
}